// Firebase
export const firebaseApiKey = 'AIzaSyAsA_YWVGv6k5bBxuClEE4xNLARmbFv0z4'
export const firebaseMessagingSenderId = '987143366371'
export const firebaseAppId = '1:987143366371:web:288b7be031b90782'

// PenTest
export const pentestFirebaseApiKey = 'AIzaSyAYhO0H3uHNoAJIy5MqIQg6vcAjJ01Kof4'
export const pentestFirebaseMessagingSenderId = '348390429841'
export const pentestFirebaseAppId = '1:348390429841:web:ba48aad8f32fdee33c1b30'
